import React, { useState } from 'react';
import { FaWhatsapp, FaPhone, FaComments, FaTimes, FaMailBulk } from 'react-icons/fa';

const WhatsAppChatInterface = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showChatPage, setShowChatPage] = useState(false);
    const [showMailPage, setShowMailPage] = useState(false);

    const phoneNumber = '8639449423';
    const whatsappURL = `https://wa.me/${phoneNumber}`;
    const callURL = `tel:${phoneNumber}`; 
    const mailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=olewinacademy@gmail.com&su=Inquiry&body=Hello%20Olewin%20Academy%20Team`;

    const handleWhatsAppClick = (e) => {
        e.preventDefault();
        setShowChatPage(true);
    };
    const closeChatPage = () => setShowChatPage(false);
    const continueToChat = () => {
        window.open(whatsappURL, '_blank');
        setShowChatPage(false);
    };

    const handleMailPageClick = (e) => {
        e.preventDefault();
        setShowMailPage(true);
    };
    const closeMailPage = () => setShowMailPage(false);
    const continueToMail = () => {
        window.open(mailURL, '_blank');
        setShowMailPage(false);
    };

    return (
        <>
            {showChatPage && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <button style={styles.closeButton} onClick={closeChatPage}>
                            <FaTimes size={20} className='bg-danger-subtle' />
                        </button>
                        <div style={styles.logoContainer}>
                            <img 
                                src="https://myacademyimages.s3.eu-north-1.amazonaws.com/channelicon2a.png" 
                                alt="olewin academy" 
                                style={{
                                    width: '250px',
                                    height: 'auto',
                                    borderRadius: '8px',
                                    objectFit: 'contain'
                                }} 
                            />
                        </div>
                        <h1 style={styles.chatTitle}>Connect on WhatsApp</h1>
                        <p style={styles.description}>
                           Connect with our expert team to learn more about our courses and programs designed to elevate your skills and career.
                        </p>
                        <button style={styles.continueButton} onClick={continueToChat}>
                            Continue to Chat
                        </button>
                    </div>
                </div>
            )}

            {showMailPage && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <button style={styles.closeButton} onClick={closeMailPage}>
                            <FaTimes size={20} className='bg-danger-subtle' />
                        </button>
                        <div style={styles.logoContainer}>
                            <img 
                                src="https://myacademyimages.s3.eu-north-1.amazonaws.com/channelicon2a.png" 
                                alt="olewin academy" 
                                style={{
                                    width: '250px',
                                    height: 'auto',
                                    borderRadius: '8px',
                                    objectFit: 'contain'
                                }} 
                            />
                        </div>
                        <h1 style={styles.chatTitle}>Continue to Email/GMail</h1>
                        <p style={styles.description}>
                           Connect with our expert team to get detailed information about our programs and courses.
                        </p>
                        <button style={styles.mailButton} onClick={continueToMail}>
                            Continue to Mail
                        </button>
                    </div>
                </div>
            )}

            <div style={styles.container}>
                {isOpen && (
                    <div style={styles.options}>
                        <a 
                            href={mailURL} 
                            onClick={handleMailPageClick}
                            style={{...styles.optionButton, backgroundColor: '#2168e1ff'}}
                        >
                            <FaMailBulk size={24} color="white" />
                        </a>
                        <a 
                            href={whatsappURL} 
                            onClick={handleWhatsAppClick}
                            style={{...styles.optionButton, backgroundColor: '#1bc75aff'}}
                        >
                            <FaWhatsapp size={24} color="white" />
                        </a>
                        <a href={callURL} style={styles.optionButton}>
                            <FaPhone size={24} color="white" />
                        </a>
                    </div>
                )}
                <button 
                    style={styles.chatButton} 
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label={isOpen ? "Close contact options" : "Open contact options"}
                >
                    {isOpen ? (
                        <FaTimes size={38} />
                    ) : (
                        <FaComments size={30} />
                    )}
                </button>
            </div>
        </>
    );
};

const styles = {
    container: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 999,
    },
    chatButton: {
        backgroundColor: '#0004ffff',
        color: 'white',
        border: 'none',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.5)',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    options: {
        display: 'flex',
        flexDirection: 'row',
        gap: '25px',
        marginBottom: '15px',
        animation: 'fadeIn 0.3s ease-out',
    },
    optionButton: {
        backgroundColor: '#008AFF',
        color: 'white',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '30px',
        maxWidth: '500px',
        width: '90%',
        position: 'relative',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#777',
        padding: '5px',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    chatTitle: {
        fontSize: '24px',
        marginBottom: '20px',
        color: '#333',
        fontWeight: 'normal',
    },
    description: {
        color: '#666',
        marginBottom: '30px',
        lineHeight: '1.5',
    },
    continueButton: {
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: '15px 30px',
        fontSize: '18px',
        cursor: 'pointer',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.3s ease',
    },
    mailButton: {
        backgroundColor: '#000000',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: '15px 30px',
        fontSize: '18px',
        cursor: 'pointer',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.3s ease',
    },
};

const styleElement = document.createElement('style');
styleElement.innerHTML = `
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;
document.head.appendChild(styleElement);

export default WhatsAppChatInterface;
